import { render, staticRenderFns } from "./MonitorGaugeMock.vue?vue&type=template&id=5996ae6a&scoped=true&"
import script from "./MonitorGaugeMock.vue?vue&type=script&lang=ts&"
export * from "./MonitorGaugeMock.vue?vue&type=script&lang=ts&"
import style0 from "./MonitorGaugeMock.vue?vue&type=style&index=0&id=5996ae6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996ae6a",
  null
  
)

export default component.exports